<template lang="html">
    <div class="supply">
        <div class="banner-img">
            <!-- <img width="100%" src="https://static.qyjmed.com/webSite/productService/supply/supply-bg.png" alt=""> -->
        </div>
        <div class="container">
            <div class="supply-content">
                <div data-wow-delay="1s" class="wow bounceInLeft supply-text">
                    <h2>关于我们</h2>
                    <h2 class="weight">ABOUT US <span></span></h2>
                    <p>在行业资讯门户网站及大数据分析基础上通过交易平台、金融及物流增值服务完成供应链金融。整合上下游企业的仓储、物流、付款。提供应收融资、存货融资、预付融资、设备融资租赁等金融服务。</p>
                    <p>全医佳雄厚的股东及基金背景，在资金成本方面拥有得天独厚的优势。与大型综合电商相比，全医佳一站式 B2B 电商平台，有能力提供更专业的资讯、建立更合适的交易和结算平台。在打造细分行业闭环和供应链金融上优势突出，在未来为行业注入新的活力。</p>
                </div>
                <div class="supply-img">
                    <img width="100%" src="https://static.qyjmed.com/webSite/productService/supply/supply.png" alt="">
                </div>
            </div>
            <div class="text-area">
                <h2>服务范围</h2>
                <img src="https://static.qyjmed.com/webSite/productService/supply/deco.png" alt="">
                <p>Service scope</p>
                <div class="scope">
                    <div class="scope-box">
                        <img src="https://static.qyjmed.com/webSite/productService/supply/supply1-1.png" alt="">
                        <p>融资租赁</p>
                    </div>
                    <div class="scope-box">
                        <img src="https://static.qyjmed.com/webSite/productService/supply/supply2-1.png" alt="">
                        <p>预付融资</p>
                    </div>
                    <div class="scope-box">
                        <img src="https://static.qyjmed.com/webSite/productService/supply/supply3-1.png" alt="">
                        <p>应收融资</p>
                    </div>
                    <div class="scope-box">
                        <img src="https://static.qyjmed.com/webSite/productService/supply/supply4-1.png" alt="">
                        <p>存货融资</p>
                    </div>
                </div>
            </div>
        </div>
        <Foot></Foot>
    </div>
</template>

<script>
import Foot from '@/components/Footer.vue'
import {WOW} from 'wowjs';
export default {
  name: 'app',
  mounted() {
      var wow=new WOW({
          live: false
      })
      wow.init()
  },
  components: {
      Foot
  }
}
</script>
<style lang="scss" scoped>
    .supply{
        .banner-img{
            margin-top: $highlight-height;
            background: url('https://static.qyjmed.com/webSite/productService/supply/supply-bg.png') center;
            height: 294px;
        }
        .container{
            .supply-content{
                .supply-text{
                    width: 650px;
                    display: inline-block;
                    vertical-align: top;
                    h2{
                        font-size: 44px;
                        line-height: 80px;
                        color: #373737;
                        &:first-child{
                            margin-top: 150px;
                        }
                        &.weight{
                            font-weight: 400;
                            span{
                                width: 18px;
                                height: 18px;
                                background: #7bc5ff;
                                display: inline-block;
                                margin-left: 50px;
                            }
                        }
                    }
                    p{
                        font-size: 18px;
                        color:#333333;
                        line-height: 36px;
                        padding-right: 80px;
                        margin-top: 30px;
                    }
                }
                .supply-img{
                    width: 550px;
                    margin-top: 54px;
                    display: inline-block;
                }
            }
            .text-area{
                text-align: center;
                h2{
                    font-size: 30px;
                    font-weight: bold;
                    margin-top: 100px;
                }
                >img{
                    margin:26px 0 30px;
                }
                >p{
                    font-size: 18px;
                    color: #6A6A6A;
                    margin-bottom: 80px;
                    letter-spacing: 8px;
                }
                .scope{
                    .scope-box{
                        width: 25%;
                        text-align: center;
                        display: inline-block;
                        img{

                        }
                        p{
                            margin-top: 36px;
                            font-size: 18px;
                            margin-bottom: 100px;
                            color: #143A6C;
                            font-weight: bold;
                        }
                    }
                }
            }
        }
    }
</style>
